import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, LinearProgress, Link, Stack, Typography } from '@mui/material';

import { formatBytes } from '~/utils/stringUtils';

interface FileProgress {
  file: File;
  progress: number;
  assetId?: string;
}

interface CreateAssetFileSelectProps {
  file: File;
  progress?: FileProgress;
  isUploading: boolean;
  onRemove: () => void;
}

export default function CreateAssetFileSelect({ file, progress, isUploading, onRemove }: CreateAssetFileSelectProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 1,
        p: 1,
        border: '1px solid',
        borderColor: 'grey.200',
      }}
    >
      <Stack spacing={1} width="100%">
        <Typography variant="body2">{file.name}</Typography>
        <Typography variant="caption" color="text.secondary">
          {formatBytes(file.size)}
        </Typography>
        {isUploading && (
          <Box>
            <LinearProgress variant="determinate" value={progress?.progress || 0} />
          </Box>
        )}
        {progress?.assetId && (
          <Link
            href={`/marketing/video-gen/preview/asset/${progress.assetId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Preview
          </Link>
        )}
      </Stack>
      <IconButton
        size="small"
        onClick={onRemove}
        disabled={isUploading || progress?.assetId !== undefined}
        sx={{
          color: isUploading || progress?.assetId !== undefined ? 'grey.400' : 'inherit',
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
